import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    
    // Check if user is already authenticated
    return this.authService.validateAuthentication().pipe(
      map(isAuthenticated => {
        if (isAuthenticated) {
          // Redirect to dashboard if already authenticated
          this.router.navigate(['/dashboard']);
          return false;
        } else {
          // Allow access to login page if not authenticated
          return true;
        }
      })
    );
  }
}
